import SettingsPage from './Settings';
import { createSettingsHandle } from './handle';

export default {
  Component: SettingsPage,
  createHandle: createSettingsHandle
};
